import { ContactUs, CopyrightFooter, DataChart, DataGrid, FindAFoundation, MaterialInput } from 'app/components'
import 'app/components/data/DataChart/config'
import { initHighcharts } from 'app/containers/App/HighchartsInit'
import { Container, IAppState } from 'app/containers/Container'
import { ResourceAction } from 'app/redux/Resources/actions';
import * as React from 'react'
import { Button, Col, ListGroup, ListGroupItem, Panel, Row, Well } from 'react-bootstrap'
import * as ReactHighmaps from 'react-highcharts/ReactHighmaps'
import { Link } from 'react-router-dom'
import { filterAndSyncFoundationMarkSources, FoundationMarkSources } from './DataSources';
import usAll from './us-all'

const styles = require('./index.less')

interface ISelectOptions {
  id: string
  display: string
}

interface IMapData {
  code: string
  value: number
  assets: number
}

interface IResourcesState {
  isLoggedIn: boolean
  username: string
  apiKey: string
  location: string
  assetLevel: string
  assetLevels: ISelectOptions[]
  states: ISelectOptions[]
  mapData: IMapData[]
}

class Resources extends Container<{}, IResourcesState> {
  private static baseFileNamePrefix = 'FoundationMark StateView - '
  private static baseFileNameSuffix = '.pdf'
  state = {
    isLoggedIn: false,
    username: null,
    apiKey: null,
    location: '',
    assetLevel: '',
    assetLevels: null,
    states: null,
    mapData: null,
  }

  componentWillMount() {
    super.componentWillMount()
    this.preloadDropdowns()
    this.loadMapData()
  }

  componentDidMount() {
    const state = this.getUrlParameter('state')

    if (state) {
      document.getElementById('state').scrollIntoView()
    }
    initHighcharts()
    filterAndSyncFoundationMarkSources(0, '')
  }

  preloadDropdowns() {
    const assetLevelRequest = { method: 'POST', body: JSON.stringify({ action: 'assetLevels', state: '', assetLevel: 0, monthNumber: 12 }) }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark', assetLevelRequest)
      .then((resp) => resp.json())
      .then((json) => {
        const assetLevels = []
        if (json.assetLevels) {
          json.assetLevels.map((assetLevel) => {
            const al = { id: assetLevel.id, display: assetLevel.levelName }
            assetLevels.push(al)
          })
        }
        this.setState({ assetLevels })
      })

    const statesRequest = { method: 'POST', body: JSON.stringify({ action: 'getStates', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } }) }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', statesRequest)
      .then((resp) => resp.text())
      .then((text) => {
        text = text.replace(/\\/g, '')
        return JSON.parse(text)
      })
      .then((json) => {
        const states = []
        if (json) {
          json.map((state) => {
            const al = { id: state.id, display: state.stateLabel }
            states.push(al)
          })
        }
        this.setState({ states })
      })
  }

  mapAppStateToContainerState(appState: IAppState): IResourcesState {
    const isLoggedIn = !!appState.User.username
    const username = appState.User.username
    return { isLoggedIn, username, apiKey: appState.User.token, assetLevel: null, location: null, assetLevels: null, states: null, mapData: [] }
  }

  getUrlParameter(sParam) {
    const hash = window.location.hash
    const search = (hash.indexOf('?') !== -1) ? hash.split('?')[1] : ''
    const sPageURL = decodeURIComponent(search)
    const sURLVariables = sPageURL.split('&')
    let sParameterName = []

    for (const variable of sURLVariables) {
      sParameterName = variable.split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  downloadFile() {
    const { isLoggedIn, username, apiKey } = this.state
    const fileName = Resources.baseFileNamePrefix + this.state.location + Resources.baseFileNameSuffix
    if (isLoggedIn) {
      ResourceAction.getFileUrl(username, apiKey, fileName).then((response) => {
        window.open(response.resource.url)
      })
    } else {
      location.hash = '#/login?fileName=' + fileName
    }
  }

  scrollToSection(e) {
    e.preventDefault();
    let id = e.currentTarget.id
    id = id.replace('_link', '')
    document.getElementById(id).scrollIntoView()
  }

  updateLocation(event) {
    this.setState({ location: event.currentTarget.value }, function () {
      filterAndSyncFoundationMarkSources(this.state.assetLevel, this.state.location)
    })
  }

  updateMapLocation(state) {
    this.setState({ location: state }, function () {
      filterAndSyncFoundationMarkSources(this.state.assetLevel, this.state.location)
    })
  }

  updateAssetLevel(event) {
    this.setState({ assetLevel: event.currentTarget.value }, function () {
      filterAndSyncFoundationMarkSources(this.state.assetLevel, this.state.location)
    })
  }

  loadMapData() {
    const statesRequest = { method: 'POST', body: JSON.stringify({ action: 'usMap', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } }) }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', statesRequest)
      .then((resp) => resp.text())
      .then((text) => {
        text = text.replace(/\\/g, '')
        return JSON.parse(text)
      })
      .then((mapData) => {
        this.setState({ mapData })
      })
  }

  render() {
    const { location, mapData } = this.state
    const MapConfig = {
      lang: { thousandsSep: ',' },
      chart: { height: 500 },
      credits: { enabled: false },
      title: { text: 'Which foundations are in the FoundationMark universe?', useHTML: true, align: 'left', style: { fontSize: '16px' } },
      colorAxis: {
        min: 1,
        max: 10000,
        type: 'logarithmic',
        minColor: '#ffffff',
        maxColor: '#2876B9',
      },
      series: [{
        name: ' ',
        data: mapData,
        mapData: usAll,
        tooltip: {
          headerFormat: null,
          footerFormat: null,
          // tslint:disable-next-line:no-invalid-template-strings
          pointFormat: '<b>{point.name}</b><br/>Foundations: {point.value}<br/>Total Assets: ${point.assets:,.1f}mm'
        },
        point: {
          events: {
            click: null
          }
        },
        joinBy: ['postal-code', 'code'],
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          format: '{point.code}'
        },
      }]
    }

    MapConfig.series[0].point.events.click = (e) => {

      this.updateMapLocation(e.point.code)
    }

    return (
      <section>
        <section className="padding-top-lg">
          <div className="container" style={{ overflowX: 'hidden', backgroundColor: '#fff' }}>
            <div className="animated fadeInLeft">
              <h1 className="hidden-xs" style={{ textAlign: 'center' }}>Resources</h1>
              <h3 className="visible-xs">Resources</h3>
              <Row className="">
                <Col md={12} className="">
                  <Row className="">
                    <Col sm={12} md={6} className="margin-y-sm">
                      <Button bsStyle="info" bsSize="lg" block href="#/assetClassReturns">Asset Class Returns</Button>
                    </Col>
                    <Col sm={12} md={6} className="margin-y-sm">
                      <Button bsStyle="info" bsSize="lg" block href="#/peergroups">Peer Groups</Button>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col sm={12} md={6} className="margin-y-sm">
                      <Button bsStyle="info" bsSize="lg" block href="#/foundationmark15">FoundationMark15</Button>
                    </Col>
                    <Col sm={12} md={6} className="margin-y-sm">
                      <Button bsStyle="info" bsSize="lg" block href="#/publications">FoundationMark Publications</Button>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col sm={12} md={6} className="margin-y-sm">
                      <Button bsStyle="info" bsSize="lg" block href="#/foundationAdvocate">FoundationAdvocate</Button>
                    </Col>
                    <Col sm={12} md={6} className="margin-y-sm">
                      <Button bsStyle="info" bsSize="lg" block href="#/faq">FAQs</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </section >

        <section className="margin-y-sm" id="state">
          <div className="container" style={{ overflowX: 'hidden' }}>
            <div className="row">
              <Well bsStyle="info">
                <h3 style={{ marginTop: 0, textAlign: 'center' }}>The FoundationMark Universe</h3>
                <p style={{ textAlign: 'justify', lineHeight: '1.3', fontSize: '20px' }}>
                  FoundationMark tracks the investment performance of over 40,000 foundations that have over $1 million in assets.  Click to see which foundations’ investment performance we track:
                </p>
              </Well>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-6">
                <Panel className="animated fadeInRight">
                  <section>
                    <ReactHighmaps config={MapConfig} />
                  </section>
                </Panel>
              </div>
              <div className="col-sm-12 col-md-6">
                <Panel className="animated fadeInRight" style={{ minHeight: '530px', maxHeight: '530px', overflowY: 'scroll' }}>
                  <section>
                    <div className="row">
                      <div className="col-sm-6">
                        <h6>Asset Levels</h6>
                        {
                          (this.state.assetLevels) ?
                            <select style={{ width: '100%' }} onChange={this.updateAssetLevel.bind(this)} value={this.state.assetLevel}>
                              {this.state.assetLevels.map((al) => <option value={al.id} key={al.id}>{al.display}</option>)}
                            </select>
                            : null
                        }
                      </div>
                      <div className="col-sm-6">
                        <h6>State</h6>
                        {(this.state.states) ?
                          <select style={{ width: '100%' }} onChange={this.updateLocation.bind(this)} value={this.state.location}>
                            {this.state.states.map((state) => <option value={state.id} key={state.id}>{state.display}</option>)}
                          </select>
                          : null
                        }
                      </div>
                    </div>
                    <div className="row margin-y">
                      <div className="col-sm-12">
                        <DataGrid DataSource={FoundationMarkSources}
                          pageSizes={[10, 15]}
                          columns={[
                            { label: 'Foundation Name', pathExpression: '$.name' },
                            { label: 'Location', pathExpression: '$.location' },
                            {
                              label: 'Total Assets', pathExpression: '$.totalAssets', customRender: (data, col) => <span>${(parseFloat(data.totalAssets.toFixed(1))).toLocaleString()}&nbsp;MM</span>
                            }]}>
                        </DataGrid>
                      </div>
                    </div>
                  </section>
                </Panel>
              </div>
            </div>
          </div>
        </section>

        <section className="margin-y-lg container" id="helpful">
          <header>
            <h3>List of Resources</h3>
          </header>
          <Row>
            <Col md={6}>
              <ListGroup className={styles.listGroupLinks} style={{ marginBottom: 0 }}>
                <ListGroupItem href="#/faq?id=investmentPerformanceReview">
                  <span>Investment Performance Review</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=expenseReview">
                  <span>FoundationMark Expense Review</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=performanceMatters">
                  <span className="hidden-lg">Performance Matters</span>
                  <span className="visible-lg">Performance Matters - Endowment Example</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=representativeBenchmarks">
                  <span>Representative Benchmarks</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=representativeBenchmarks">
                  <span>FoundationMark Universe</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col md={6}>
              <ListGroup className={styles.listGroupLinks}>
                <ListGroupItem href="#/faq?id=portfolioFoundations">
                  <span>Portfolio Foundations</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=portfolioFoundations">
                  <span>Asset Class Definitions</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=indicesAndPeerGroups">
                  <span>Indices and Peer Groups</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=fatTail">
                  <span>Measuring Returns</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
                <ListGroupItem href="#/faq?id=fatTail">
                  <span>“Fat Tail” Distribution</span>
                  <Button bsStyle="info">See More</Button>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
        </section>

        <footer>
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section >
    )
  }
}

export {
  Resources,
}



// WEBPACK FOOTER //
// ./src/app/containers/Resources/index.tsx